import React from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import DashboardPage from './pages/Dashboard';
import UsersPage from './pages/Users';
import TransactionsPage from './pages/Transactions';
import ReconciliationPage from './pages/Reconciliation';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import { GlobalStyles } from './components/GlobalStyles';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import { AuthProvider } from './authContext/AuthContext';

import './App.scss';
import ToastNoti from './components/Noti';

function App() {
  return (
    <AuthProvider>
      <GlobalStyles />
      <ToastNoti />
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        {/* <Route
          path="/register"
          element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute>
          }
        /> */}

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/transactions" element={<TransactionsPage />} />
                  <Route path="/reconciliation" element={<ReconciliationPage />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
